import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-right":"10px"} }, "产品明细", -1)
const _hoisted_2 = { style: {"font-size":"12px","color":"#1890ff"} }
const _hoisted_3 = { style: {"font-size":"13px","font-weight":"bold","color":"#d4b106"} }
const _hoisted_4 = { style: {"font-weight":"bold","color":"#1890ff"} }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_alert_outlined = _resolveComponent("alert-outlined")!
  const _component_appstore_outlined = _resolveComponent("appstore-outlined")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      title: '提交新版本',
      width: 1000,
      visible: _ctx.visible,
      onOk: _ctx.onSubmit,
      onCancel: _ctx.onClose
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_spin, {
          tip: "加载中...",
          spinning: _ctx.isLoading
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["check-form", { disabled: _ctx.disabled }])
            }, [
              _createVNode(_component_a_form, {
                ref: "formRef",
                model: _ctx.form,
                rules: _ctx.rules,
                layout: "vertical"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_divider, { orientation: "left" }, {
                    default: _withCtx(() => [
                      _createTextVNode("基本配置")
                    ]),
                    _: 1
                  }),
                  (!_ctx.projectId)
                    ? (_openBlock(), _createBlock(_component_a_row, {
                        key: 0,
                        gutter: 16
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "关联产品",
                                name: "productId"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_select, {
                                    value: _ctx.form.productId,
                                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.productId) = $event)),
                                    "allow-clear": "",
                                    style: {"width":"100%"},
                                    placeholder: "请选择关联产品",
                                    onChange: _ctx.productChange
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productList, (item) => {
                                        return (_openBlock(), _createBlock(_component_a_select_option, {
                                          key: item.id,
                                          value: item.id
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.productName), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["value", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 12 })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.form.productId)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (!_ctx.projectId)
                          ? (_openBlock(), _createBlock(_component_a_row, {
                              key: 0,
                              gutter: 16
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_col, { span: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, { name: "projectId" }, {
                                      label: _withCtx(() => [
                                        _hoisted_1,
                                        _createVNode(_component_a_tag, {
                                          color: _ctx.getSelectedProductType.isStrictly ? 'error' : 'default'
                                        }, {
                                          icon: _withCtx(() => [
                                            (_ctx.getSelectedProductType.isStrictly)
                                              ? (_openBlock(), _createBlock(_component_alert_outlined, { key: 0 }))
                                              : (_openBlock(), _createBlock(_component_appstore_outlined, { key: 1 }))
                                          ]),
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.getSelectedProductType.isStrictly ? '医疗产品' : '非医疗产品'), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["color"])
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_radio_group, {
                                          value: _ctx.form.projectId,
                                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.projectId) = $event)),
                                          onChange: _ctx.onChange_ProductDetail
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productDetailList, (item) => {
                                              return (_openBlock(), _createBlock(_component_a_radio_button, {
                                                key: item.id,
                                                value: item.id
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.global.platform[item.productType]?.text) + "（" + _toDisplayString(item.productCode) + "）", 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["value", "onChange"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.useJenkinsConstruct)
                          ? (_openBlock(), _createBlock(_component_a_row, {
                              key: 1,
                              gutter: 16
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_col, { span: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, { name: "commitNum" }, {
                                      label: _withCtx(() => [
                                        _createTextVNode(" Git提交记录 ")
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_select, {
                                          value: _ctx.form.commitNum,
                                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.commitNum) = $event)),
                                          loading: _ctx.commitNumLoading,
                                          style: {"width":"100%"},
                                          placeholder: "请选择提交项",
                                          onChange: _ctx.changeBranch
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gitSubmitList, (item) => {
                                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                                key: item.value,
                                                value: item.data.shortNo
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("span", _hoisted_2, _toDisplayString(item.data.shortDate) + " " + _toDisplayString(item.data.shortTime), 1),
                                                  _createTextVNode("  "),
                                                  _createElementVNode("span", _hoisted_3, _toDisplayString(item.data.submitUser), 1),
                                                  _createTextVNode(" " + _toDisplayString(item.data.description), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["value", "loading", "onChange"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createVNode(_component_a_row, { gutter: 16 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_col, { span: 24 })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_row, { gutter: 16 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_col, { span: 12 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_form_item, {
                                        label: "是否启用",
                                        name: "enable"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_switch, {
                                            checked: _ctx.form.enable,
                                            "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.enable) = $event)),
                                            "checked-children": "启用",
                                            "un-checked-children": "禁用"
                                          }, null, 8, ["checked"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_col, { span: 12 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_form_item, {
                                        label: "是否发布",
                                        name: "release"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_switch, {
                                            checked: _ctx.form.release,
                                            "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.release) = $event)),
                                            "checked-children": "是",
                                            "un-checked-children": "否",
                                            onChange: _ctx.onChange_isRelease
                                          }, null, 8, ["checked", "onChange"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_row, { gutter: 16 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_col, { span: 12 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_form_item, {
                                        label: "预约发布",
                                        name: "releaseDate"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_switch, {
                                            checked: _ctx.form.isReserveRelease,
                                            "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.isReserveRelease) = $event)),
                                            "checked-children": "是",
                                            "un-checked-children": "否",
                                            onChange: _ctx.onChange_isReserveRelease
                                          }, null, 8, ["checked", "onChange"]),
                                          _createTextVNode("  "),
                                          (_ctx.form.isReserveRelease)
                                            ? (_openBlock(), _createBlock(_component_a_date_picker, {
                                                key: 0,
                                                value: _ctx.form.releaseDate,
                                                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.releaseDate) = $event)),
                                                "show-time": ""
                                              }, null, 8, ["value"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_col, { span: 12 })
                                ]),
                                _: 1
                              })
                            ], 64)),
                        _createVNode(_component_a_row, { gutter: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "所属分支",
                                  name: "branchName"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_select, {
                                      value: _ctx.form.branchName,
                                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.branchName) = $event)),
                                      style: {"width":"100%"},
                                      placeholder: "请选择所属分支",
                                      onChange: _ctx.changeBranch
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productBranchList, (item) => {
                                          return (_openBlock(), _createBlock(_component_a_select_option, {
                                            key: item.branchName,
                                            value: item.branchName
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("span", _hoisted_4, _toDisplayString(item.branchName), 1),
                                              _createTextVNode(" " + _toDisplayString(item.description), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["value", "onChange"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "发布版本",
                                  name: "environment"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_select, {
                                      value: _ctx.form.environment,
                                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.environment) = $event)),
                                      style: {"width":"100%"},
                                      placeholder: "请选择发布版本",
                                      onChange: _ctx.changeEnvironment
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getEnvironmentList, (key) => {
                                          return (_openBlock(), _createBlock(_component_a_select_option, {
                                            key: key,
                                            value: key
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.global.environment[key]), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["value", "onChange"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_row, { gutter: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, { name: "version" }, {
                                  label: _withCtx(() => [
                                    _createTextVNode(" 版本号 "),
                                    (_ctx.minVersion)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, "（最小版本号：" + _toDisplayString(_ctx.minVersion) + "）", 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_input, {
                                      value: _ctx.form.version,
                                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.version) = $event))
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "是否强制更新",
                                  name: "isForceuUpgrade"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_switch, {
                                      checked: _ctx.form.forceUpgrade,
                                      "onUpdate:checked": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.forceUpgrade) = $event)),
                                      "checked-children": "是",
                                      "un-checked-children": "否"
                                    }, null, 8, ["checked"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.getProductVesions.length && (_ctx.useJenkinsConstruct || _ctx.form.environment === _ctx.global.environment.production))
                          ? (_openBlock(), _createBlock(_component_a_row, {
                              key: 3,
                              gutter: 16
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_col, { span: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, { name: "prevVersionIds" }, {
                                      label: _withCtx(() => [
                                        _createTextVNode(" 继承版本 ")
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_select, {
                                          value: _ctx.form.prevVersionIds,
                                          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.prevVersionIds) = $event)),
                                          mode: "multiple",
                                          loading: _ctx.commitNumLoading,
                                          style: {"width":"100%"},
                                          placeholder: "请选择继承版本",
                                          onChange: _ctx.changeBranch
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getProductVesions, (item) => {
                                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                                key: item.value,
                                                value: item.value
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(item.version), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["value", "loading", "onChange"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_a_row, { gutter: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "升级说明",
                                  name: "updateContent"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_textarea, {
                                      value: _ctx.form.updateContent,
                                      "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.updateContent) = $event)),
                                      rows: 3
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.getJenkensConfig.length)
                          ? (_openBlock(), _createBlock(_component_a_divider, {
                              key: 4,
                              orientation: "left"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Jenkins配置")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.getJenkensConfig.length)
                          ? (_openBlock(), _createBlock(_component_a_row, {
                              key: 5,
                              gutter: 16
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_col, { span: 24 }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getJenkensConfig || [], (item) => {
                                      return (_openBlock(), _createBlock(_component_a_form_item, {
                                        key: item.key,
                                        label: item.key,
                                        name: item.key
                                      }, {
                                        default: _withCtx(() => [
                                          (item.type === 'int')
                                            ? (_openBlock(), _createBlock(_component_a_input_number, {
                                                key: 0,
                                                value: _ctx.form.jenkinsExtraConfig[item.key],
                                                "onUpdate:value": ($event: any) => ((_ctx.form.jenkinsExtraConfig[item.key]) = $event),
                                                min: "0",
                                                max: "1",
                                                style: {"width":"100%"}
                                              }, null, 8, ["value", "onUpdate:value"]))
                                            : (_openBlock(), _createBlock(_component_a_input, {
                                                key: 1,
                                                value: _ctx.form.jenkinsExtraConfig[item.key],
                                                "onUpdate:value": ($event: any) => ((_ctx.form.jenkinsExtraConfig[item.key]) = $event),
                                                style: {"width":"100%"}
                                              }, null, 8, ["value", "onUpdate:value"]))
                                        ]),
                                        _: 2
                                      }, 1032, ["label", "name"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_a_divider, { orientation: "left" }, {
                          default: _withCtx(() => [
                            _createTextVNode("其他配置")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_row, { gutter: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "存在问题及改进建议",
                                  name: "issue"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_textarea, {
                                      value: _ctx.form.issue,
                                      "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.issue) = $event)),
                                      rows: 2
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_row, { gutter: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "备注",
                                  name: "productVersionRemark"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_textarea, {
                                      value: _ctx.form.productVersionRemark,
                                      "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.productVersionRemark) = $event)),
                                      rows: 2
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createVNode(_component_a_row, { gutter: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_alert, {
                                  message: "暂无对应数据，请先选择产品",
                                  banner: ""
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _hoisted_6
                      ], 64))
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ], 2)
          ]),
          _: 1
        }, 8, ["spinning"])
      ]),
      _: 1
    }, 8, ["visible", "onOk", "onCancel"])
  ]))
}